import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: 'Home', href: '/', current: location.pathname === '/' },
    { name: 'Team', href: '/team', current: location.pathname === '/team' },
    { name: 'Socials', href: '/socials', current: location.pathname === '/socials' },
    { name: 'Charity', href: '/charity', current: location.pathname === '/charity' },
    { name: 'Events', href: '/events', current: location.pathname === '/events' },
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img
            src="/TCST_RoundLogo_Lowres.png.png"
            alt="The Canopy Stream Team"
            onError={(e) => {
              e.target.src = "/TCST_LeafIcon_Lowres.png.png";
            }}
          />
          <div>
            <h1 className="text-gradient">The Canopy</h1>
            <p style={{fontSize: '0.75rem', color: 'var(--forest-600)', marginTop: '-0.25rem'}}>Stream Team</p>
          </div>
        </Link>

        {/* Hamburger Menu Button - Mobile Only */}
        <button
          className="hamburger-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          <div className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></div>
        </button>

        {/* Desktop Navigation */}
        <div className="nav-links desktop-nav">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              style={{
                color: item.current ? 'var(--forest-500)' : 'var(--forest-700)'
              }}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Mobile Navigation Overlay */}
        <div 
          className={`mobile-nav-overlay ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(false)}
        ></div>

        {/* Mobile Navigation Menu */}
        <div className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <div className="mobile-nav-content">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="mobile-nav-link"
                onClick={() => setIsMenuOpen(false)}
                style={{
                  color: item.current ? 'var(--forest-500)' : 'var(--forest-700)'
                }}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;